import { FireResultCard } from "./results-card";
import { formatAmount } from "../../../helpers";

interface FireResultsProps {
  fireNumber: number;
  leanFire: number;
  fatFire: number;
  coastFire: number;
}

export function FireResults({
  fireNumber,
  leanFire,
  fatFire,
  coastFire,
}: FireResultsProps) {
  return (
    <div className="bg-[#1C1C1C] rounded-lg p-8 ">
      <div className="flex flex-col items-center justify-center">
        <h2 className="text-xl font-semibold mb-2 text-white ">
          Your FIRE Number
        </h2>
        <div className="text-[#E6D5B8] text-5xl font-bold italic mb-8 bg-gradient-text text-transparent bg-clip-text">
          {formatAmount(fireNumber)}
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4">
        <FireResultCard
          type="Lean FIRE"
          amount={formatAmount(leanFire)}
          description="Achieve financial independence by living a minimalist lifestyle"
        />
        <FireResultCard
          type="Fat FIRE"
          amount={formatAmount(fatFire)}
          description="Luxury comforts with your dream life of Financial Independence"
        />
      </div>

      <FireResultCard
        type="Coast FIRE"
        amount={formatAmount(coastFire)}
        description="Save early, let compounding work its magic, and focus only on covering your current expenses - 'coasting' on your early savings."
        className="w-full"
      />
    </div>
  );
}
